import { useLocation, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAuthenticator } from '@aws-amplify/ui-react';

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  // Wait only for Amplify's explicit configuring state.
  // The lower-level route can remain "setup" on first load even after auth
  // has already resolved to unauthenticated, which blanks the home page.
  if (authStatus === 'configuring') {
    return null;
  }

  if (authStatus !== 'authenticated') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <Helmet />
      {children}
    </>
  );
};

export default RequireAuth;
